import Head from "next/head";
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import PageBreadcrumb from "../PageBreadcrumb";
import { setKeywords, setTags } from "../../store/actions/keywordActions";
import Keywords from "./Keywords";
import NotSelected from "../NotSelected";

const KeywordContainer = ({ type="ranking", routes  }) => {
  const domain = useSelector((state) => state.domains.currentDomain);
  const dispatch = useDispatch();

  useEffect(() => {
    if (domain !== null) {
      dispatch(setKeywords(domain._id));
      dispatch(setTags(domain._id))
    }
  }, [domain]);

  return (
    <>
      {domain !== null ? (
        <>
          <Head>
            <title>{ routes[0].name } { routes[1].name }</title>
          </Head>
          <PageBreadcrumb
            routes={routes}
          />
          <Keywords type={type} pageName={ routes[1].name }  />
        </>
      ) : (
        <NotSelected title="Please Select Domain." />
      )}
    </>
  );
};

export default KeywordContainer;
